<script setup>
import { ref } from 'vue'

const partners = ref([
	{
		logo: 'https://d1f3y6u6f3nh06.cloudfront.net/images/partners/mount-sinai.png',
		name: 'Mount Sinai',
	},
	{
		logo: 'https://d1f3y6u6f3nh06.cloudfront.net/images/partners/ablegamers.png',
		name: 'Mount Sinai',
	},
	{
		logo: 'https://d1f3y6u6f3nh06.cloudfront.net/images/partners/adaptive.png',
		name: 'Mount Sinai',
	},
])
</script>

<template>
	<section id="overview" class="bg-gradient-to-t from-mint-100 to-white py-12 lg:py-16">
		<div class="container">
			<div class="flex flex-col items-center justify-center gap-8 text-center md:gap-12">
				<h2 class="accent-text text-4xl font-bold uppercase md:text-5xl lg:text-7xl">$25,000 IN CASH &amp; PRIZES</h2>
				<p class="leading-relaxed md:text-lg md:leading-relaxed lg:text-2xl lg:leading-relaxed xl:px-48">Logitech has partnered with the Mount Sinai, AbleGamers Charity and Adaptive Action Sports to to provide adaptive gamers a professional series of esports tournaments featuring high stakes, bragging rights, and $25,000+ in cash &amp; prizes.</p>
				<div class="mt-4 flex flex-wrap items-center justify-center gap-8 lg:gap-16">
					<img class="h-12 lg:h-16" v-for="(partner, i) in partners" :key="i" :src="partner.logo" :alt="partner.name + ' Logo'" />
				</div>
			</div>
		</div>
	</section>
</template>
